/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
// import MetaTags from "react-meta-tags";
import * as Utils from "./Utils";
import NotificationAlert from "react-notification-alert";
// reactstrap components
import {
  Button,
  Badge,
  Card,
  CardImg,
  CardTitle,
  CardBody,
  CardSubtitle,
  CardText,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Label,
  Nav,
  NavLink,
  Input,
  Row,
  Spinner,
  UncontrolledTooltip,
  UncontrolledDropdown,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
// import CommentsBlock from "simple-react-comments";
// import { arrayOf } from "prop-types";
// import { Fragment } from "react";
// import { Helmet } from "react-helmet";
// TODO: Replace with MUI Autocomplete - temporarily disabled for React 18 upgrade
// import ChipInput from "material-ui-chip-input";
import logo from "assets/img/ziro.png";

// TODO CLEANUP: Remove deprecated config4js.js imports (ZAI-68)
// config4js.js is deprecated in favor of service_config.js
// Use window.getBackendUrl() instead
// See: https://tadepalli.atlassian.net/browse/ZAI-68
// import { serverUrl } from "../config4js.js";

// Use service_config.js instead (loaded globally via index.html)
// Fail gracefully if config_loader hasn't loaded yet
let serverUrl;
if (typeof window.getBackendUrl === 'function') {
  serverUrl = window.getBackendUrl();
} else if (window.ZIRO_BACKEND_URL) {
  serverUrl = window.ZIRO_BACKEND_URL;
} else {
  console.error('❌ ProjectInfo: config_loader.js not loaded! Backend URL not available.');
  // Don't set a fallback - let it fail clearly so the issue is obvious
  serverUrl = null;
}

function ProjectInfo(props) {
  //hooks for profile info
  const [profilePic, setProfilePic] = React.useState(logo);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [tagline, setTagline] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [city, setCity] = React.useState("");

  const [programs, setPrograms] = React.useState([]);
  const notificationAlertRef = React.useRef(null);
  const [isUser, setIsUser] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [projDesc, setProjDesc] = React.useState("");
  const [pblic, setPublic] = React.useState(false);
  const [tags, setTags] = React.useState([]);
  const [projectID, setProjectID] = React.useState("");
  const [userID, setUserID] = React.useState("");
  const [starred, setStarred] = React.useState(false);
  const [flag, setFlag] = useState(false);
  const [power, setPower] = useState(false);

  const [lists, setLists] = React.useState([]);
  const [checkedState, setCheckedState] = React.useState(
    new Array(lists.length).fill(false)
  );
  const [checkboxModal, setCheckboxModal] = React.useState(false);
  //hook for spinner animations
  const [loading, setLoading] = React.useState(true);
  const [loadingUser ,setLoadingUser] = React.useState(true);

  //once props updates, fetch projectID from URL
  useEffect(() => {
    fetchID();
  }, [props.userID]);

  function fetchID() {
    const projectRegex = new RegExp("\\?id=(.*)"); //regex to extract project ID
    const reArr = projectRegex.exec(document.URL); //get array with regex
    setProjectID(reArr[1]); 
    setFlag(flag => !flag); //using a flag to detect if user logs in and props subsequently updates, as projectID is static once set
  }

  //once we succesfully get project id, fetch project info
  useEffect(() => {
    fetchProjectInfo();
    fetchUserLists();
    isStarred();
  }, [flag]);

  //get project info and update program hook with response
  function fetchProjectInfo() {
    if (!serverUrl) {
      console.error("❌ ProjectInfo.fetchProjectInfo: Backend URL not available. config_loader.js may not have loaded.");
      return;
    }
    if(projectID){
      var xhr = new XMLHttpRequest();
      // construct API endpoint from serverUrl and route in server
      var apiEndpoint = serverUrl + "/fetchproject?file_id=" + projectID;
      console.log(apiEndpoint);
      xhr.open(
        "GET",
        apiEndpoint //"https://zirostudio.appspot.com/fetchproject?file_id=" + projectID
      );
      xhr.onload = function () {
        var tmpPrograms = JSON.parse(xhr.responseText);
        console.log(tmpPrograms)
        setPrograms(tmpPrograms);
      };
      xhr.send();
    }
  }

  useEffect(() => {
    if(programs.length > 0){
      setLoading(false);
    }
  })
  
  //fetching the lists of the user viewing the page
  function fetchUserLists(){ 
    var id_token = Utils.getCookie("ziroatoken");
    if(id_token){
      Utils.getUserLists(id_token, userListCallback)
    }
  }

  //callback function for fetchUserLists, update with response here
  function userListCallback(res){
    if(res){
      setLists(res);
    }
  }

  //function to check if project has stars
  function isStarred() {
    // Get session_id from cookie or localStorage
    var sessionId = Utils.getCookie("ziroatoken");
    if (!sessionId) {
      sessionId = localStorage.getItem('ziro_session_id');
    }
    // Fail gracefully if serverUrl is not available
    if (!serverUrl) {
      console.error("❌ ProjectInfo.isStarred: Backend URL not available. config_loader.js may not have loaded.");
      return;
    }
    
    // Verify it's a session_id (UUID format)
    const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
    if (!isSessionId) {
      console.error("❌ ProjectInfo.isStarred: No valid session_id found");
      return;
    }
    
    var xhr = new XMLHttpRequest();
    const projectRegex = new RegExp("\\?id=(.*)");
    const reArr = projectRegex.exec(document.URL);
    // Use session_id parameter (backend only accepts session_id now)
    var apiEndpoint = serverUrl + "/isprojectstarred?session_id=" + sessionId;
    console.log(apiEndpoint);
    xhr.open(
      "POST",
      apiEndpoint //"https://zirostudio.appspot.com/isprojectstarred?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      if (JSON.parse(xhr.responseText)[0] !== undefined) {
        setStarred(JSON.parse(xhr.responseText)[0]["starred"]);
      }
      //xhr.send(JSON.stringify({'project_to_check': reArr[1]}));
    };
    xhr.send(JSON.stringify({ project_to_check: reArr[1] }));
  }

  //now once we have program info, get info about user who posted it
  useEffect(() => {
    fetchUserInfo();
  }, [programs]);

  function fetchUserInfo() {
    if (programs.length > 0) {
      const usersID = programs[0].user_id;
      setUserID(programs[0].user_id);
      setTitle(programs[0].title);
      setProjDesc(programs[0].description);
      setTags(programs[0].other_tags);
      setPublic(programs[0].public);
      Utils.getProfile(usersID, profileCallback);
    }
  }

  function isPowerUser() {
    // Fail gracefully if serverUrl is not available
    if (!serverUrl) {
      console.error("❌ ProjectInfo.isPowerUser: Backend URL not available. config_loader.js may not have loaded.");
      return;
    }
    
    // Get session_id from cookie or localStorage
    var sessionId = Utils.getCookie("ziroatoken");
    if (!sessionId) {
      sessionId = localStorage.getItem('ziro_session_id');
    }
    // Verify it's a session_id (UUID format)
    const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
    if (!isSessionId) {
      console.error("❌ ProjectInfo.isPowerUser: No valid session_id found");
      return;
    }
    
    // Make request to check if user is power user
    var xhr = new XMLHttpRequest();
    // Use session_id parameter (backend only accepts session_id now)
    var apiEndpoint = serverUrl + "/ispoweruser?session_id=" + sessionId;
    console.log(apiEndpoint);
    xhr.open(
      "POST",
      apiEndpoint
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.onload = function () {
      // parse string as boolean
      setPower(JSON.parse(xhr.responseText).power_user);
    }
    xhr.onerror = function() {
      console.error("❌ ProjectInfo.isPowerUser: Network error calling", apiEndpoint);
    }
    xhr.send()
  }

  useEffect(() => {
    if(userID && props.userID){
      if(userID === props.userID){
        setIsUser(true);
        isPowerUser();
      } else {
        setIsUser(false);
      }
    }
  }, [userID, props.userID])

  function profileCallback(res){
    // Handle unauthenticated users or error cases gracefully
    // Page should still work without profile data
    if(!res || typeof res === 'string'){
      // No profile data available (user is unauthenticated or error occurred)
      // Page continues to work, just without profile-specific information
      console.log("ProjectInfo: No profile data available - continuing without user profile");
      return;
    }
    
    if(res.first_name) setFirstName(res.first_name);
    if(res.last_name) setLastName(res.last_name);
    if(res.username) setUsername(res.username);
    if(res.city) setCity(res.city);
    if(res.tagline) setTagline(res.tagline);
    
    // Handle img_url - it can be a string or an object with img_url property
    if(res.img_url){
      if(typeof res.img_url === 'string'){
        setProfilePic(res.img_url);
      } else if(res.img_url.img_url){
      setProfilePic(res.img_url.img_url);
      }
    }
  }
  
  useEffect(() => {
    if(firstName !== ""){
      setLoadingUser(false);
    }
  }, [firstName])

  useEffect(() => {
    setCheckedState(new Array(Object.keys(lists).length).fill(false));
  }, [lists]);

  function addToPlaylist(fileID) {
    var id_token = Utils.getCookie("ziroatoken");
    Utils.addPlaylist(id_token, fileID, lists, addToPlayListCallback);
    setProjectID(fileID);
  }

  function addToPlayListCallback(res){
    setCheckedState(res);
    toggleCheckboxModal();
  }

  function toggleCheckboxModal() {
    setCheckboxModal(!checkboxModal);
  }

  //TODO: modify backend to handle adding one project to multiple lists
  function addProjectToPlaylist(checkedState, projID) {
    //loop through checkedState to see which ones were selected
    let playlistIds = [];

    for (let i = 0; i < checkedState.length; i++) {
      if (checkedState[i] === true) {
        playlistIds.push(lists[i].playlist_id);
      }
    }

    if (playlistIds) {
      // Get session_id from cookie or localStorage (once for all requests)
      var sessionId = Utils.getCookie("ziroatoken");
      if (!sessionId) {
        sessionId = localStorage.getItem('ziro_session_id');
      }
      // Verify it's a session_id (UUID format)
      const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
      if (!isSessionId) {
        console.error("❌ ProjectInfo.addProjectToPlaylist: No valid session_id found");
        return;
      }
      
      for (let i = 0; i < playlistIds.length; i++) {
        var xhr = new XMLHttpRequest();
        // Use session_id parameter (backend only accepts session_id now)
        if (!serverUrl) {
          console.error("❌ ProjectInfo.addProjectToPlaylist: Backend URL not available. config_loader.js may not have loaded.");
          return;
        }
        var apiEndpoint = serverUrl +  "/editplaylist?session_id=" + sessionId;
        console.log(apiEndpoint);
        xhr.open(
          "POST",
          apiEndpoint //"https://zirostudio.appspot.com/editplaylist?authtoken=" + id_token
        );
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          Utils.notify(
            "Added project to list(s) successfully.",
            notificationAlertRef
          );
          toggleCheckboxModal();
        };

        xhr.send(
          JSON.stringify({
            playlist_id: playlistIds[i],
            file_id: projID,
            operation: true,
          })
        );
      }
    }
    playlistIds = [];
  }
  
  //if a list was checkmarked, update state here
  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);
  };

  function editProject(title, description, fileID) {
    // Get session_id from cookie or localStorage
    var sessionId = Utils.getCookie("ziroatoken");
    if (!sessionId) {
      sessionId = localStorage.getItem('ziro_session_id');
    }
    // Verify it's a session_id (UUID format)
    const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
    if (!isSessionId) {
      console.error("❌ ProjectInfo.editProject: No valid session_id found");
      return;
    }
    
    let sanitizedTitle = sanitizeString(title);
    let sanitizedDesc = sanitizeString(description);
    if(sanitizedTitle.length > 50 || sanitizedDesc.length > 250 || !sanitizedTitle || !sanitizedDesc){
      return;
    }
    var xhr = new XMLHttpRequest();
    // Use session_id parameter (backend only accepts session_id now)
    if (!serverUrl) {
      console.error("❌ ProjectInfo.editProject: Backend URL not available. config_loader.js may not have loaded.");
      return;
    }
    var apiEndpoint = serverUrl + "/editproject?session_id=" + sessionId;
    console.log(apiEndpoint);
    xhr.open(
      "POST",
      apiEndpoint //"https://zirostudio.appspot.com/editproject?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      toggleModal();
      fetchProjectInfo();
    };

    xhr.send(
      JSON.stringify({
        file_id: fileID,
        title: sanitizedTitle,
        description: sanitizedDesc,
        public: pblic,
        other_tags: tags,
      })
    );
  }

  function sanitizeString(str){
    str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
    return str.trim();
  }

  function copyProject() {
    // Get session_id from cookie or localStorage
    var sessionId = Utils.getCookie("ziroatoken");
    if (!sessionId) {
      sessionId = localStorage.getItem('ziro_session_id');
    }
    // Verify it's a session_id (UUID format)
    const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
    if (!isSessionId) {
      console.error("❌ ProjectInfo.copyProject: No valid session_id found");
      return;
    }
    
    var xhr = new XMLHttpRequest();
    // Use session_id parameter (backend only accepts session_id now)
    if (!serverUrl) {
      console.error("❌ ProjectInfo.copyProject: Backend URL not available. config_loader.js may not have loaded.");
      return;
    }
    var apiEndpoint = serverUrl + "/copyproject?session_id=" + sessionId;
    console.log(apiEndpoint);
    xhr.open(
      "POST",
      apiEndpoint //"https://zirostudio.appspot.com/copyproject?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xhr.onload = function () {
      window.open(
        "/project-info?id=" + xhr.responseText
      );
    };

    xhr.send(JSON.stringify({ orig_project_id: projectID }));
  }

  function switchStar() {
    // Get session_id from cookie or localStorage
    var sessionId = Utils.getCookie("ziroatoken");
    if (!sessionId) {
      sessionId = localStorage.getItem('ziro_session_id');
    }
    // Verify it's a session_id (UUID format)
    const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
    if (!isSessionId) {
      console.error("❌ ProjectInfo.switchStar: No valid session_id found");
      return;
    }
    
    if (starred) {
      Utils.notify("Project unstarred.", notificationAlertRef);
      setStarred(false);
    } else {
      Utils.notify("Project starred.", notificationAlertRef);
      setStarred(true);
    }

    var xhr = new XMLHttpRequest();
    // Use session_id parameter (backend only accepts session_id now)
    if (!serverUrl) {
      console.error("❌ ProjectInfo.starProject: Backend URL not available. config_loader.js may not have loaded.");
      return;
    }
    var apiEndpoint = serverUrl + "/starproject?session_id=" + sessionId;
    console.log(apiEndpoint);
    xhr.open(
      "POST",
      apiEndpoint //"https://zirostudio.appspot.com/starproject?authtoken=" + id_token
    );
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.onload = function () {
      fetchProjectInfo();
    };

    xhr.send(
      JSON.stringify({ project_star: projectID, star_or_unstar: starred })
    );
  }

  function toggleModal() {
    setModal(!modal);
  }

  // if user exits out of edit project modal, reset values
  const resetProjVal = () => {
    toggleModal();
    setTitle(programs[0].title);
    setProjDesc(programs[0].description);
  }
  
  return (
    <>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <div className="content">
        {programs.length === 0 && loading  ? (
          <Row>
            <Col>
              <Spinner
                animation="border"
                color="info"
                style={{
                  padding: 0,
                  margin: 7,
                  marginLeft: 15,
                }}
              />
            </Col>
          </Row>
        )
        : null}
        {programs.map((item) => {
          return (
            <Row>
              <Col sm={7}>
                <Nav>
                  <NavLink
                    href={"/studio?code=" + item["file_id"]}
                    style={{ paddingLeft: 3, paddingRight: 0 }}
                  >
                    <Button
                      color="success"
                      className="animation-on-hover btn-simple"
                    >
                      Studio{" "}
                      <i
                        className="tim-icons icon-double-right"
                        style={{ transform: "translate(0px, -2px)" }}
                      />
                    </Button>
                  </NavLink>
                  {props.auth === 1 ? (
                    <>
                    <NavLink href="#" style={{ paddingRight: 4 }}>
                      <UncontrolledDropdown>
                        <Button
                          color="info"
                          className="animation-on-hover btn-simple"
                          onClick={switchStar}
                        >
                          {starred ? (
                            <i
                              className="fas fa-star"
                              style={{
                                transform: "translate(0px, -0px)",
                                marginRight: 5,
                              }}
                            />
                          ) : (
                            <i
                              className="far fa-star"
                              style={{
                                transform: "translate(0px, -0px)",
                                marginRight: 5,
                              }}
                            />
                          )}
                          {item["num_star"]}
                        </Button>
                      </UncontrolledDropdown>
                    </NavLink>
                    <NavLink style={{ paddingRight: 0 }}>
                      <UncontrolledTooltip
                        placement="top"
                        target="duplicate"
                        style={{ pointerEvents: "none" }}
                      >
                        Copy Project
                      </UncontrolledTooltip>
                      <Button
                        className="animation-on-hover btn-round btn-icon"
                        color="success"
                        onClick={copyProject}
                        id="duplicate"
                      >
                        <i class="fas fa-copy"></i>
                      </Button>
                    </NavLink>
                      <NavLink>
                        <UncontrolledTooltip
                          placement="top"
                          target="list"
                          style={{ pointerEvents: "none" }}
                        >
                          Add to List
                        </UncontrolledTooltip>
                        <Button
                          className="btn-round btn-icon animation-on-hover"
                          color="success"
                          style={{ cursor: "pointer"}}
                          onClick={() => {addToPlaylist(item['file_id'])}}
                          id="list"
                        >
                          <i className="fas fa-plus" />
                        </Button>
                      </NavLink>
                      </>
                  ) : null}
                  {isUser ? (
                    <NavLink>
                      <UncontrolledTooltip
                        placement="top"
                        target="edit"
                        style={{ pointerEvents: "none" }}
                      >
                        Edit Project Details
                      </UncontrolledTooltip>
                      <Button
                        className="btn-round btn-icon animation-on-hover"
                        color="success"
                        style={{ cursor: "pointer", marginLeft: -15 }}
                        onClick={toggleModal}
                        id="edit"
                      >
                        <i className="tim-icons icon-pencil" />
                      </Button>
                    </NavLink>
                  ) : (
                    <br></br>
                  )}
                  {/* Blockly Project Flag */}
                  <div
                                                  
                    style = {{
                      display: item["blockly"] ? "inline-block" : "none",
                    }}
                    
                    >
                      <Button
                      className="btn-round btn-icon animation-on-hover"
                      color="success"
                      style={{ cursor: "pointer", marginLeft: 0, marginTop: 12}}
                     
                    >
                    <p> <i
                        class="fa-solid fa-b"
                        
                      /> {item["blockly"] ? "B" : ""}
                    </p></Button>
                      
                  </div>
                </Nav>

                <Modal
                  isOpen={checkboxModal}
                  toggle={toggleCheckboxModal}
                  style={{ paddingBottom: 10 }}
                  backdropClassName={"modal-dark"}
                  size="sm"
                >
                  <ModalHeader>
                    <h4
                      className="modal-title"
                      id="exampleModalLabel"
                    >
                      Save to...
                    </h4>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                      onClick={toggleCheckboxModal}
                    >
                      <i className="tim-icons icon-simple-remove" />
                    </button>
                  </ModalHeader>
                  {lists.length === 0 && props.auth === 1 ? (
                    <Row>
                      <Col>
                        <p style={{color: "#000", marginLeft: 25, marginTop: 15}}>
                          You don't have any lists. Create a list 
                          <a href="/user-view"> here!</a>
                        </p>
                      </Col>
                    </Row>
                  )
                  : null}
                  {lists.map((key, index) => {
                    return (
                      <>
                        <ModalBody
                          style={{
                            padding: 5,
                            paddingLeft: 20,
                            paddingBottom: -10,
                          }}
                        >
                          <FormGroup check>
                            <Label
                              check
                              htmlFor={`custom-checkbox-${index}`}
                            >
                              <Input
                                type="checkbox"
                                id={`custom-checkbox-${index}`}
                                name={key.title}
                                value={key.title}
                                checked={
                                  checkedState[index]
                                }
                                onChange={() =>
                                  handleOnChange(index)
                                }
                              />
                              {key.title}
                              <span className="form-check-sign">
                                <span className="check"></span>
                              </span>
                            </Label>
                          </FormGroup>
                        </ModalBody>
                      </>
                    );
                  })}

                  <ModalFooter>
                  {lists.length === 0 ? (
                    <Button
                    color="success"
                    className="animation-on-hover"
                    style={{
                      marginLeft: 24,
                      marginBottom: 16,
                      marginTop: 15,
                    }}
                    disabled
                  >
                    Add to List
                  </Button>
                  )
                  : <Button
                    color="success"
                    className="animation-on-hover"
                    style={{
                      marginLeft: 24,
                      marginBottom: 16,
                      marginTop: 15,
                    }}
                    onClick={() =>
                      addProjectToPlaylist(
                        checkedState,
                        projectID
                      )
                    }
                  >
                    Add to List
                  </Button>}
                  </ModalFooter>
                </Modal>
              </Col>
              <Col></Col>
              <br></br>
              <br></br>
              <br></br>
              <Col xl="6">
              <NavLink
                  href={"/studio?code=" + item["file_id"]}
                  style={{ paddingLeft: 3, paddingRight: 0 }}
                >
                <Card>
                  <img
                    className="img-fluid"
                    onError={Utils.addDefaultSrc}
                    src={Utils.getThumbnailUrl(item["file_id"])}
                  ></img>
                  <CardBody>
                    <Row>
                      <Col md="auto">
                        <CardTitle>
                          <h1 style={{ marginBottom: 0, display: 'inline-block', wordWrap: 'break-word' }}>
                            {item["title"]}
                          </h1>
                        </CardTitle>
                      </Col>
                      <Col>
                        <Modal
                          isOpen={modal}
                          toggle={toggleModal}
                          style={{ paddingBottom: 10 }}
                          backdropClassName={"modal-dark"}
                        >
                          <div className="modal-header">
                            <h3 className="modal-title" id="exampleModalLabel">
                              Edit Project
                            </h3>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-hidden="true"
                              onClick={resetProjVal}
                            >
                              <i className="tim-icons icon-simple-remove" />
                            </button>
                          </div>
                          <ModalBody>
                            <FormGroup
                              className={title.length > 50 || title.length === 0 ? "has-danger" : ""}
                            >
                              <Label for="exampleEmail">
                                <h4 style={{ color: "black", marginBottom: 0 }}>
                                  Project Name
                                </h4>
                              </Label>
                              <Input
                                type="text"
                                id="projName"
                                defaultValue={programs[0]["title"]}
                                onChange={(txt) => setTitle(txt.target.value)}
                                // onBlur={(txt) => {
                                //   if (txt.target.value.length <= 50 && txt.target.value.length > 0 ) {
                                //     programs[0]["title"] = txt.target.value;
                                //   }
                                // }}
                              ></Input>
                              <p
                                style={{
                                  fontSize: "smaller",
                                  alignContent: "right",
                                  color: title.length > 50 || title.length === 0 ? "red" : "",
                                }}
                                className="float-right"
                              >
                                {title.length + "/50"}
                              </p>
                            </FormGroup>
                            <FormGroup
                              className={ projDesc.length > 250 || projDesc.length === 0 ? "has-danger" : "" }
                            >
                              <Label for="exampleEmail">
                                <h4 style={{ color: "black", marginBottom: 0 }}>
                                  Project Description
                                </h4>
                              </Label>
                              <Input
                                type="text"
                                id="projDescription"
                                defaultValue={programs[0]["description"]}
                                onChange={(txt) => setProjDesc(txt.target.value)}
                                // onBlur={(txt) => {
                                //   if (txt.target.value.length <= 250 && txt.target.value.length > 0) {
                                //     programs[0]["description"] = txt.target.value;
                                //   }
                                // }}
                              />
                              <p
                                style={{
                                  fontSize: "smaller",
                                  alignContent: "right",
                                  color: projDesc.length > 250 || projDesc.length === 0 ? "red" : "",
                                }}
                                className="float-right"
                              >
                                {projDesc.length + "/250"}
                              </p>
                            </FormGroup>
                            <FormGroup>
                              <Label for="exampleEmail">
                                <h4 style={{ color: "black", marginBottom: 0 }}>
                                  Tags
                                </h4>
                                {
                                  /*<Badge color="success">physics</Badge>
                                  <Badge color="warning">coding</Badge>
                                  <Badge color="danger">robotics</Badge>
                                  <Badge color="info">custom</Badge>*/
                                }
                              </Label>
                              {/* TODO: Replace ChipInput with MUI Autocomplete - temporarily disabled for React 18 upgrade
                              <ChipInput
                                onChange={(chips) =>
                                  setTags(
                                    chips.map((chip) => {
                                      return chip.toLowerCase();
                                    })
                                  )
                                }
                                variant="outlined"
                                chipRenderer={Utils.renderChip}
                                classes={{
                                  inputRoot: "input-chip-tags-root",
                                  input: "input-chip-tags-input",
                                }}
                                style={{ width: "100%" }}
                                dataSource={[
                                  "physics",
                                  "math",
                                  "coding",
                                  "robotics",
                                ]}
                                defaultValue={item["other_tags"]}
                                newChipKeyCodes={[13, 188]}
                                placeholder={"Enter comma-separated tags"}
                              ></ChipInput>
                              */}
                              <p style={{color: "#888", fontStyle: "italic"}}>Tag editing temporarily disabled during upgrade. Will be restored soon.</p>
                            </FormGroup>
                            {power ? (
                              <FormGroup check>
                                <h4 style={{ color: "black", marginBottom: 0 }}>
                                  Visibility
                                </h4>
                                <Label check>
                                  <Input type="checkbox" 
                                    checked={pblic}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setPublic(true);
                                      } else {
                                        setPublic(false);
                                      }
                                    }}
                                  /> Public
                                  <span className="form-check-sign">
                                    <span className="check"></span>
                                  </span>
                                </Label>
                              </FormGroup>
                            ) : (
                              <br></br>
                            )}
                            {
                              /*<FormGroup>
                                <Label for="exampleEmail">
                                  <h4 style={{ color: "black", marginBottom: 0 }}>
                                    Thumbnail
                                  </h4>
                                  To capture a thumbnail, go to Studio and press
                                  the <i className="fas fa-camera" /> icon.
                                </Label>
                              </FormGroup>*/
                            }
                          </ModalBody>
                          <ModalFooter>
                           {title.length > 50 || title.trim().length === 0 || projDesc.length > 250 || projDesc.trim().length === 0 ? (
                            <Button
                              className="animation-on-hover"
                              color="success"
                              style={{ marginLeft: 24, marginBottom: 16 }}
                              disabled
                            >
                              Save Changes
                            </Button>
                           ) : (                                
                            <Button
                              className="animation-on-hover"
                              color="success"
                              style={{ marginLeft: 24, marginBottom: 16 }}
                              onClick={() =>
                                editProject(title, projDesc, item["file_id"])
                              }
                            >
                              Save Changes
                            </Button>
                          )}
                          </ModalFooter>
                        </Modal>
                      </Col>
                    </Row>

                    <Row>
                      <CardBody style={{ paddingTop: 0, marginLeft: 2 }}>
                        <CardText>{item["description"]}</CardText>
                      </CardBody>
                    </Row>
                    <Row>
                      <Col>
                        {"physics_tag" in item &&
                          item["physics_tag"] == true && (
                            <Badge color="success">physics</Badge>
                          )}
                        {"coding_tag" in item && item["coding_tag"] == true && (
                          <Badge color="warning">coding</Badge>
                        )}
                        {"robotics_tag" in item &&
                          item["robotics_tag"] == true && (
                            <Badge color="danger">robotics</Badge>
                          )}
                        {"other_tags" in item &&
                          item["other_tags"].map(
                            (tag) =>
                              tag != "physics" &&
                              tag != "coding" &&
                              tag != "robotics" && (
                                <Badge color="info">{tag}</Badge>
                              )
                          )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                </NavLink>
              </Col>
              <Col>
                <Row>
                  <Col xs={4}>
                    <div>
                      <Card className="text-center">
                        <CardImg
                          top
                          width="100%"
                          src={profilePic}
                          alt="User Profile Pic"
                        ></CardImg>
                        <CardBody>
                          <CardTitle tag="h3">Created by {username}</CardTitle>
                          {loadingUser  ? (
                            <Row>
                              <Col>
                                <Spinner
                                  animation="border"
                                  color="info"
                                  style={{
                                    padding: 0,
                                    margin: 7,
                                    marginLeft: 15,
                                  }}
                                />
                              </Col>
                            </Row>
                          )
                          : null}
                          <CardSubtitle className="mb-2 text-muted">
                            {firstName + " " + lastName}
                          </CardSubtitle>
                          <CardSubtitle className="mb-2 text-muted">
                            {city}
                          </CardSubtitle>
                          <CardSubtitle className="mb-2 text-muted">
                            {tagline}
                          </CardSubtitle>
                        </CardBody>
                      </Card>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          );
        })}
        {/*
        <Row>
          <Col md="7">
            <Card>
              <CardHeader><h2 className="title">Comments</h2></CardHeader>
              <CardBody>
                <Card>
                  <CardBody><CardText>A comment.</CardText></CardBody>
                </Card>

                <Card>
                  <CardBody><CardText>Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Suspendisse convallis eget mauris eget laoreet. Fusce suscipit nibh nulla, nec cursus dolor consectetur at.</CardText></CardBody>
                </Card>

                <Card>
                  <CardBody><CardText>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In egestas fermentum erat. Aliquam feugiat leo eros, nec faucibus velit ultricies vitae. Curabitur at mauris at nisl tempor vehicula. Sed tincidunt eget augue a pharetra. Nullam accumsan porta magna, id tempus tortor dapibus sit amet. Aenean vulputate orci sit amet iaculis semper. Ut hendrerit sapien lacus, nec sodales metus ultricies a. Donec posuere risus leo, convallis fermentum sem iaculis at..</CardText></CardBody>
                </Card>

                <Card>
                  <CardBody><CardText>This is super cool!</CardText></CardBody>
                </Card>

                <Card>
                  <CardBody><CardText>Cras dictum nulla fermentum, ullamcorper ipsum at, facilisis lacus. Duis malesuada augue eget augue sodales finibus. Duis cursus, ipsum nec viverra rhoncus</CardText></CardBody>
                </Card>
              </CardBody>
            </Card>
          </Col>        
        </Row>*/}
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  userID: state.userID,
  auth: state.auth,
});

export default connect(mapStateToProps)(ProjectInfo);
